module.exports = __webpack_public_path__ + "img/43_81.d9aad538.png";